import { render, staticRenderFns } from "./Cabinet.vue?vue&type=template&id=d7271ba2"
import script from "./Cabinet.vue?vue&type=script&lang=js"
export * from "./Cabinet.vue?vue&type=script&lang=js"
import style0 from "./Cabinet.vue?vue&type=style&index=0&id=d7271ba2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports